export default "__VITE_ASSET__CBysOSmo__"